// export const NEXT_CLOUD_BASE_URL = 'https://drive.easychain.fr';
export const NEXT_CLOUD_BASE_URL = 'https://drive.connect-credit.net';
export const NEXT_CLOUD_WEBDAV_SHARE_ENDPOINT = `${NEXT_CLOUD_BASE_URL}/public.php/webdav`;
export const MAX_INPUT_LENGTH = 500;
